var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "9icedo2u6a",
    cx: 28,
    cy: 28,
    r: 28
  }), /*#__PURE__*/React.createElement("path", {
    id: "q5r96z42vc",
    d: "M8.377 15.353L3.313 10.29 0 13.58 8.377 21.957 27.043 3.29 23.753 0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-655.000000, -136.000000) translate(655.000000, 136.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "z1wvqn9elb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#9icedo2u6a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "red",
    xlinkHref: "#9icedo2u6a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#00C566",
    mask: "url(#z1wvqn9elb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 56L56 56 56 0 0 0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H56V56H0z",
    transform: "translate(-655.000000, -136.000000) translate(655.000000, 136.000000)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L56 0 56 56 0 56z",
    transform: "translate(-655.000000, -136.000000) translate(655.000000, 136.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-655.000000, -136.000000) translate(655.000000, 136.000000) translate(14.956667, 17.710000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ljni5x956d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q5r96z42vc"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#q5r96z42vc"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#ljni5x956d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 56L56 56 56 0 0 0z",
    transform: "translate(-14.956667, -17.710000)"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.24887d413aa15fabfe7d2cba8acedc2a.svg";
export { ForwardRef as ReactComponent };